import { useTranslation } from 'react-i18next';

import { Button } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';
import { FeedPandaModal } from '@app/shared/ui/organisms/Home/FeedPandaModal';
import { FeedPandaSuccessModal } from '@app/shared/ui/organisms/Home/FeedPandaSuccessModal';
import { useFeedPandaModal } from '@app/shared/hooks/useFeedPandaModal';

interface FeedPandaSectionProps {
  lastPandaFed?: number | null;
  containerClassName?: string;
}

export function FeedPandaSection({ lastPandaFed, containerClassName }: FeedPandaSectionProps) {
  const { t } = useTranslation();
  const {
    handleFeedPandaClick,
    handleFeedPandaSuccess,
    closeModal: closeFeedModal,
    isFeedModalOpen,
    isFeedSuccessModalOpen,
    isExpired,
    formattedLeft,
  } = useFeedPandaModal(lastPandaFed);

  return (
    <>
      <Button
        variant="custom"
        className={cn(
          'relative flex h-fit shrink-0 items-center overflow-hidden px-3 py-2.5',
          !isExpired ? 'justify-between' : 'justify-center',
          containerClassName
        )}
        onClick={handleFeedPandaClick}
      >
        <div
          className={cn('absolute inset-0 rounded-lg border border-home-card-border')}
          style={{
            backgroundImage: 'linear-gradient(to right, #FFFFFF12, #6fded1cc, #FFFFFF12)',
            backgroundColor: !isExpired ? 'rgba(2,17,79,0.32)' : 'transparent',
            backgroundBlendMode: 'overlay',
          }}
        />

        <div
          className={cn(
            'relative text-[11px] text-nowrap font-bold leading-[1.2] text-foreground',
            isExpired && 'text-[#A00060] font-roboto text-shadow-dark'
          )}
        >
          {t('home.feed_panda')}
        </div>

        {!isExpired && (
          <div className="relative text-[9px] leading-[1.2] text-foreground">
            {t('home.feed_panda_in')} {formattedLeft}
          </div>
        )}
      </Button>

      <FeedPandaModal
        isOpen={isFeedModalOpen}
        onOpenChange={closeFeedModal}
        onFeedSuccess={handleFeedPandaSuccess}
        isTimerExpired={isExpired}
      />

      <FeedPandaSuccessModal isOpen={isFeedSuccessModalOpen} onOpenChange={closeFeedModal} />
    </>
  );
}
